const AUTOMATIC_PDF_READY = 'AUTOMATIC_PDF_READY';
const FINAL_PDF_READY = 'FINAL_PDF_READY';
export const REJECTED = 'REJECTED';
export const REJECTED_WITH_ERROR = 'REJECTED_WITH_ERROR';
const STATUS_SAI_NEEDS_TO_COMPLETE = 'STATUS_SAI_NEEDS_TO_COMPLETE';
const VERIFYING_AREA_LIMITATIONS = 'VERIFYING_AREA_LIMITATIONS';
const BRASTER_INFORMATION_READY = 'BRASTER_INFORMATION_READY';
const THERMOGRAMS_READY = 'THERMOGRAMS_READY';

export const examinationCanBeDisplayed = examination =>
    [
        AUTOMATIC_PDF_READY,
        FINAL_PDF_READY,
        REJECTED,
        REJECTED_WITH_ERROR,
        BRASTER_INFORMATION_READY,
        THERMOGRAMS_READY,
    ].includes(examination.currentStatus);

export const examinationIsRejected = examination => [REJECTED, REJECTED_WITH_ERROR].includes(examination.currentStatus);
export const examinationNeedsToComplete = examination => examination.currentStatus === STATUS_SAI_NEEDS_TO_COMPLETE;
export const examinationIsVerifyingAreaLimitations = examination =>
    examination.currentStatus === VERIFYING_AREA_LIMITATIONS;
export const examinationBrasterInformationReady = examination =>
    examination.currentStatus === BRASTER_INFORMATION_READY;
export const examinationThermogramsReady = examination => examination.currentStatus === THERMOGRAMS_READY;

export const BASIC_AUTOMATIC_ANALYSIS = 'BASIC_AUTOMATIC_ANALYSIS';
export const DEEPPROCESSING = 'DEEPPROCESSING';
export const BRASTER_INFORMATION = 'BRASTER_INFORMATION';
export const MANUAL_EVALUATION = 'MANUAL_EVALUATION';



// WEBPACK FOOTER //
// ./src/assets/js/examinationUtils.js